export const solutions = {
  is: {
    title: "Stafrænar lausnir fyrir framtíðina",
    description: "Við bjóðum upp á fjölbreyttar lausnir sem hjálpa fyrirtækjum að vaxa og dafna í stafrænum heimi.",
    sections: {
      title: "Lausnir sem skila árangri",
      description: "Sérhannaðar lausnir fyrir þitt fyrirtæki",
      ai: {
        title: "Gervigreind",
        description: "AI lausnir sem auka skilvirkni og bæta þjónustu"
      },
      booking: {
        title: "Bókunarkerfi",
        description: "Sjálfvirk bókunarkerfi fyrir alla atvinnustarfsemi"
      },
      subscription: {
        title: "Áskriftarkerfi",
        description: "Öflug áskriftarkerfi fyrir endurteknar tekjur"
      },
      ecommerce: {
        title: "Netverslun",
        description: "WooCommerce og Shopify netverslanir"
      },
      pos: {
        title: "Kassakerfi",
        description: "Nútímaleg POS kerfi fyrir verslanir og veitingastaði"
      },
      wordpress: {
        title: "WordPress",
        description: "Sérsniðnar WordPress lausnir fyrir öll fyrirtæki"
      },
      wordpressExpress: {
        title: "WordPress Express",
        description: "Hraðvirk og hagkvæm WordPress lausn"
      },
      hosting: {
        title: "Vefhýsing",
        description: "Örugg og áreiðanleg hýsing með 99.9% uppitíma"
      },
      email: {
        title: "Tölvupóstur",
        description: "Fagleg netföng með þínu léni"
      },
      management: {
        title: "Vefumsjón",
        description: "Reglulegt viðhald og öryggisvöktun"
      },
      chat: {
        title: "Netspjall",
        description: "AI spjallmenni fyrir betri þjónustu"
      }
    },
    cta: {
      title: "Viltu ræða þína hugmynd?",
      description: "Við hjálpum þér að finna réttu lausnina fyrir þitt fyrirtæki"
    }
  },
  en: {
    title: "Digital Solutions for the Future",
    description: "We offer diverse solutions that help businesses grow and thrive in the digital world.",
    sections: {
      title: "Solutions that Deliver Results",
      description: "Custom solutions for your business",
      ai: {
        title: "AI Solutions",
        description: "AI solutions that increase efficiency and improve service"
      },
      booking: {
        title: "Booking System",
        description: "Automated booking systems for all industries"
      },
      subscription: {
        title: "Subscription System",
        description: "Powerful subscription systems for recurring revenue"
      },
      ecommerce: {
        title: "E-commerce",
        description: "WooCommerce and Shopify online stores"
      },
      pos: {
        title: "POS System",
        description: "Modern POS systems for retail and restaurants"
      },
      wordpress: {
        title: "WordPress",
        description: "Custom WordPress solutions for all businesses"
      },
      wordpressExpress: {
        title: "WordPress Express",
        description: "Fast and cost-effective WordPress solution"
      },
      hosting: {
        title: "Web Hosting",
        description: "Secure and reliable hosting with 99.9% uptime"
      },
      email: {
        title: "Email",
        description: "Professional email addresses with your domain"
      },
      management: {
        title: "Web Management",
        description: "Regular maintenance and security monitoring"
      },
      chat: {
        title: "Live Chat",
        description: "AI chatbot for better service"
      }
    },
    cta: {
      title: "Want to discuss your idea?",
      description: "We'll help you find the right solution for your business"
    }
  },
  es: {
    title: "Soluciones Digitales para el Futuro",
    description: "Ofrecemos diversas soluciones que ayudan a las empresas a crecer y prosperar en el mundo digital.",
    sections: {
      title: "Soluciones que Entregan Resultados",
      description: "Soluciones personalizadas para tu empresa",
      ai: {
        title: "Soluciones de IA",
        description: "Soluciones de IA que aumentan la eficiencia y mejoran el servicio"
      },
      booking: {
        title: "Sistema de Reservas",
        description: "Sistemas de reservas automatizados para todas las industrias"
      },
      subscription: {
        title: "Sistema de Suscripción",
        description: "Sistemas de suscripción potentes para ingresos recurrentes"
      },
      ecommerce: {
        title: "Comercio Electrónico",
        description: "Tiendas online con WooCommerce y Shopify"
      },
      pos: {
        title: "Sistema POS",
        description: "Sistemas POS modernos para retail y restaurantes"
      },
      wordpress: {
        title: "WordPress",
        description: "Soluciones WordPress personalizadas para todas las empresas"
      },
      wordpressExpress: {
        title: "WordPress Express",
        description: "Solución WordPress rápida y económica"
      },
      hosting: {
        title: "Hosting",
        description: "Hosting seguro y confiable con 99.9% de tiempo activo"
      },
      email: {
        title: "Correo Electrónico",
        description: "Direcciones de correo profesionales con tu dominio"
      },
      management: {
        title: "Gestión Web",
        description: "Mantenimiento regular y monitoreo de seguridad"
      },
      chat: {
        title: "Chat en Vivo",
        description: "Chatbot con IA para mejor servicio"
      }
    },
    cta: {
      title: "¿Quieres discutir tu idea?",
      description: "Te ayudaremos a encontrar la solución correcta para tu empresa"
    }
  },
  da: {
    title: "Digitale Løsninger for Fremtiden",
    description: "Vi tilbyder forskellige løsninger, der hjælper virksomheder med at vokse og trives i den digitale verden.",
    sections: {
      title: "Løsninger der Leverer Resultater",
      description: "Skræddersyede løsninger til din virksomhed",
      ai: {
        title: "AI-løsninger",
        description: "AI-løsninger der øger effektiviteten og forbedrer service"
      },
      booking: {
        title: "Bookingsystem",
        description: "Automatiserede bookingsystemer til alle brancher"
      },
      subscription: {
        title: "Abonnementssystem",
        description: "Kraftfulde abonnementssystemer til tilbagevendende omsætning"
      },
      ecommerce: {
        title: "E-handel",
        description: "WooCommerce og Shopify webshops"
      },
      pos: {
        title: "POS-system",
        description: "Moderne POS-systemer til detail og restauranter"
      },
      wordpress: {
        title: "WordPress",
        description: "Skræddersyede WordPress-løsninger til alle virksomheder"
      },
      wordpressExpress: {
        title: "WordPress Express",
        description: "Hurtig og omkostningseffektiv WordPress-løsning"
      },
      hosting: {
        title: "Webhosting",
        description: "Sikker og pålidelig hosting med 99.9% oppetid"
      },
      email: {
        title: "Email",
        description: "Professionelle emailadresser med dit domæne"
      },
      management: {
        title: "Webadministration",
        description: "Regelmæssig vedligeholdelse og sikkerhedsovervågning"
      },
      chat: {
        title: "Live Chat",
        description: "AI chatbot til bedre service"
      }
    },
    cta: {
      title: "Vil du diskutere din idé?",
      description: "Vi hjælper dig med at finde den rigtige løsning til din virksomhed"
    }
  }
};